import { CpdConfigs } from '../cpd/cpd-configs';
import { Page } from '../page/page';
import { Course } from './courses';

export declare class CoursePage extends Page {
  public course: Course;
  cpdConfigs: CpdConfigs[];
}
